export default __webpack_public_path__ + "static/media/user1.f3714f33.jpg";